import React, { useContext, useEffect, useState } from "react";

import db from "../../services/query";
import Img from "../common/Img";
import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";
import { EmptyState, LoadingState } from "../common/SurfaceUI";
import { PopUpContext } from "../../contexts/popUpContext";
import lbl from "../../data/Labels.json";

const dash = (value) => (value === null || value === undefined || value === "" ? "—" : value);

const InfoProfile = (props) => {
  const { tid } = props.match.params;
  const { togglePopUp, popUp } = useContext(PopUpContext);
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const requestData = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await db.getAll(`teachers/${tid}`);
      setTeacher(data?.data?.[0] || null);
    } catch (_) {
      setError("بارگیری معلومات استاد ناموفق بود.");
      setTeacher(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    requestData();
  }, [tid, popUp]);

  if (loading) return <LoadingState />;
  if (error) {
    return (
      <EmptyState
        title={error}
        action={<button type="button" onClick={requestData}>بارگیری مجدد</button>}
      />
    );
  }
  if (!teacher) return <EmptyState title="معلومات استاد پیدا نشد." />;

  const fields = [
    { label: "نام", value: teacher.teacher_name },
    { label: "نام انگلیسی", value: teacher.teacher_name_en },
    { label: "کد استاد", value: teacher.aria_id },
    { label: "شماره تماس", value: teacher.teacher_phone },
    { label: "ایمیل", value: teacher.teacher_email },
    { label: "تاریخ تولد", value: teacher.teacher_dob },
    { label: "جنسیت", value: teacher.gender },
    { label: "پوهنحی", value: teacher.faculty },
    { label: "دپارتمنت", value: teacher.department },
    { label: "شغل دوم", value: Number(teacher.second_job) === 1 ? "بلی" : "نخیر" },
    { label: "عمومی", value: Number(teacher.is_general) === 1 ? "بلی" : "نخیر" },
    { label: "وضعیت حساب", value: Number(teacher.user_status) === 1 ? "برحال" : "اسبق" },
  ];

  return (
    <div className="student-info">
      <div id="general-info-header">
        <div className="student-detail five-col">
          <div className="detail_item">
            <p>نام</p>
            <p>{dash(teacher.teacher_name)}</p>
          </div>
          <div className="detail_item">
            <p>کد استاد</p>
            <p>{dash(teacher.aria_id)}</p>
          </div>
          <div className="detail_item">
            <p>شماره تماس</p>
            <p>{dash(teacher.teacher_phone)}</p>
          </div>
          <div className="detail_item">
            <p>پوهنحی</p>
            <p>{dash(teacher.faculty)}</p>
          </div>
          <div className="detail_item">
            <div style={{ width: "50%", float: "right" }}>
              <p>جنسیت</p>
              <p>{dash(teacher.gender)}</p>
            </div>
            <div className="left-content">
              <MainButton
                type="pen"
                title={lbl.Edit}
                handleClick={() =>
                  togglePopUp({
                    form: "teacher-form",
                    edit: teacher,
                    callback: requestData,
                  })
                }
              />
            </div>
          </div>
          <div className="detail_item">
            <p>ایمیل</p>
            <p>{dash(teacher.teacher_email)}</p>
          </div>
          <div className="detail_item">
            <p>دپارتمنت</p>
            <p>{dash(teacher.department)}</p>
          </div>
          <div className="detail_item">
            <p>تاریخ تولد</p>
            <p>{dash(teacher.teacher_dob)}</p>
          </div>
        </div>
        <div className="profile-image">
          <Img src={teacher.teacher_photo} alt="" />
        </div>
      </div>

      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title="معلومات عمومی" />
        </div>
      </div>
      <div className="student-detail">
        {fields.map((field) => (
          <div className="detail_item" key={field.label}>
            <p>{field.label}</p>
            <p>{dash(field.value)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoProfile;
